import {dataTemplate} from './dataTemplate';

const Settings = dataTemplate('settings');

export const WEEKBLOCK_ID = 'weekblocks'
export default Settings;
